/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors, gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { overflowEllipsis } from 'src/styles/mixins';

export const IssueLink = styled.a`
  overflow: hidden;
  display: flex;
  align-items: center;

  &,
  &:hover,
  &:focus {
    color: ${token('color.text', colors.N800)};
  }
`;

export const JiraIssueTypeIconContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const JiraIssueTypeIcon = styled.img`
  flex-shrink: 0;
  width: ${gridSize() * 2}px;
  height: ${gridSize() * 2}px;
  padding-right: ${gridSize()}px;
`;

export const IssueKey = styled.span`
  padding-right: ${gridSize()}px;
  color: ${token('color.text.subtlest', colors.N200)};
  white-space: nowrap;
`;

export const IssueSummary = styled.div`
  ${overflowEllipsis()};
`;

export const IssueSummaryWrapper = styled.div`
  overflow: hidden;
`;
